import { render, staticRenderFns } from "./IntegrationCreatedDateTableCell.vue?vue&type=template&id=a93d2ffe&scoped=true"
import script from "./IntegrationCreatedDateTableCell.vue?vue&type=script&lang=js"
export * from "./IntegrationCreatedDateTableCell.vue?vue&type=script&lang=js"
import style0 from "./IntegrationCreatedDateTableCell.vue?vue&type=style&index=0&id=a93d2ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93d2ffe",
  null
  
)

export default component.exports